import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { ExcelService } from 'src/app/service/excel-service';
import { FiltroRomaneioLista } from '../filter/filtro-romaneio-lista';
import { CabecalhoRomaneio, defaultCabecalhoRomaneio } from '../interface/romaneio';
import { Veiculo } from '../interface/veiculo';
import { RomaneioService } from '../service/romaneio.service';
import { VeiculoLookupService } from '../service/veiculo-lookup-service';

@Component({
  selector: 'app-romaneio-lista',
  templateUrl: './romaneio-lista.component.html',
  styleUrls: ['./romaneio-lista.component.css']
})
export class RomaneioListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRomaneioLista;

  novoCadastroRomaneio: CabecalhoRomaneio;

  varOrigemDestino: Array<PoSelectOption>;
  varStatus: Array<PoSelectOption>;

  veiculoAdvancedFilters: Array<PoDynamicFormField>;
  veiculoColumnsFilters: Array<PoLookupColumn>;
  veiculoFieldFormaterFilters: (value: Veiculo) => string;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private excelService: ExcelService,
    public veiculoLookupService: VeiculoLookupService,
  ) {

    this.tabelaPrincipalFiltro = new FiltroRomaneioLista(this.poStorageService);

    this.novoCadastroRomaneio = defaultCabecalhoRomaneio();

    this.veiculoAdvancedFilters      = this.veiculoLookupService.getAdvancedFilter();
    this.veiculoColumnsFilters       = this.veiculoLookupService.getColumnsFilter();
    this.veiculoFieldFormaterFilters = this.veiculoLookupService.getFieldFormater;

    this.varOrigemDestino = this.listaOrigemDestino();
    this.varStatus = this.listaStatus();

  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('criarRomaneioModal', { static: true }) criarRomaneioModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.lista(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items;
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ00COD'   , label: 'Código'          , width: '100px'},
    {property: 'DZ00DATA'  , label: 'Data'            , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ00DESTIN', label: 'Destino'         , width: '10%', type: 'label',
      labels: [
        { value: 'SO', color: 'color-01',  label: 'SOLIDA'    },
        { value: 'BA', color: 'color-05',  label: 'CD SOLIDA' },
      ]
    },
    {property: 'CZ00PLACA' , label: 'Placa'           , width: '8%'},
    {property: 'CZ00USER'  , label: 'Usuário'         , width: '7%'},
    {property: 'CUSRNOME'  , label: 'Nome Usuário'    , width: '20%'},
    {property: 'CZ00HORA'  , label: 'Hora'            , width: '10%'},
    {property: 'CZ00STATUS', label: 'Status'          , width: '15%', type: 'label',
      labels: [
        { value: 'A', color: 'color-08',  label: 'Pend. Confirmação'  },
        { value: '0', color: 'color-01',  label: 'Pend. Envio'        },
        { value: '1', color: 'color-05',  label: 'Pend. Recebimento'  },
        { value: 'Z', color: 'color-12',  label: 'Recebido'           },
      ]
    },
  ];

  public readonly tabelaPrincipalAction: Array<PoTableAction> = [
    {
      action: this.editar.bind(this),
      icon: 'po-icon-edit',
      label: 'Editar',
      disabled: this.editarDisabled.bind(this)
    },
    {
      action: this.openDialogConfirmarExcluirRomaneio.bind(this),
      icon: 'po-icon-delete',
      label: 'Excluir',
      disabled: this.editarDisabled.bind(this)
    },
    {
      action: this.downloadPDF.bind(this),
      icon: 'po-icon-pdf',
      label: 'PDF',
      disabled: this.pdfDisabled.bind(this)
    },
    {
      action: this.downloadCSV.bind(this),
      icon: 'po-icon-doc-xls',
      label: 'CSV',
      disabled: this.pdfDisabled.bind(this)
    }
  ]

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Criação Romaneio', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  public readonly criarRomaneioAction: PoModalAction = {
    action: () => {
      this.novoRomaneio();
    },
    label: 'Confirmar'
  };

  openModalNovoRomaneio(): void {
    this.criarRomaneioModal.open();
  }

  novoRomaneio(): void {
    if (this.novoCadastroRomaneio.CZ00DESTIN != '' && this.novoCadastroRomaneio.CZ00PLACA != '') {
      this.criarRomaneioModal.close();
      this.romaneioService.criarRomaneio(this.novoCadastroRomaneio).subscribe((ret) => {
        this.router.navigateByUrl(`/estoque/romaneio/cadastro/${ret.CZ00COD}`);
      });
    } else {
      this.poNotificationService.error("Por favor, preencha todas as informações!");
    }
  }

  editar(row: CabecalhoRomaneio): void {
    this.router.navigateByUrl(`/estoque/romaneio/cadastro/${row.CZ00COD}`);
  }

  openDialogConfirmarExcluirRomaneio(row: CabecalhoRomaneio): void {
    this.poDialogService.confirm({
      title: 'Excluir Romaneio',
      message: 'Deseja realmente excluir o romaneio?',
      confirm: () => this.excluirRecebimentoMercadoria(row)
    });
  }

  excluirRecebimentoMercadoria(row: CabecalhoRomaneio ): void {
    this.romaneioService.excluirRomaneio(row.CZ00COD).subscribe( () => {
      this.tabelaPrincipalLoad();
    });
  }

  downloadPDF(row: CabecalhoRomaneio): void {
    this.romaneioService.getPdfRomaneio(row.CZ00COD).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${row.CZ00COD}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  downloadCSV(row: CabecalhoRomaneio): void {
    this.romaneioService.getObjCompleto(row.CZ00COD).subscribe((res) => {
      const lista_excel = res.itemsRecebidos.map( (item) => {
        return{
          'Ordem'             :  item.CC5PEDEXP,
          'Cliente'           :  item.CA1NOME,
          'Material'          :  item.CB1DESC,
          'Pedido de Venda'   :  item.CC5NUM,
          'Lote'              :  item.CZ02LOTE,
          'Qtd Pç'            :  item.NZ01QUANT,
          'Volume'            :  item.NQTDORI2,
          'Fator Conv.'       :  item.NB1CONV,
          'Informação'        :  item.CZ02INFORM,
          'Nº UR'             :  item.CZ02UR,
          'M3 Pallet'         :  item.NM3PALLET, 
          'Código Estruturado':  item.CB1COD,
          'RTL Material'      :  item.CB1RTL,
          'Peso'              :  item.NZ02PESO, 
          'NFE'               :  item.CC5NOTA,
          'Situação'          :  'Concluído',
         
        }
      });

      this.excelService.exportAsExcelFile(lista_excel, `${row.CZ00COD}`);
    });
  }

  editarDisabled(row: CabecalhoRomaneio): boolean {
    return row.CZ00STATUS != "A" && row.CZ00STATUS != "0";
  }

  pdfDisabled(row: CabecalhoRomaneio): boolean {
    return row.CZ00STATUS == "A" || row.CZ00STATUS == "0";
  }

  alteraDestino(): void {
    if (this.novoCadastroRomaneio.CZ00DESTIN == 'BA') {
      this.novoCadastroRomaneio.CZ00ORIGEM = 'SO';
    } else {
      this.novoCadastroRomaneio.CZ00ORIGEM = 'BA';
    }
  }

  listaOrigemDestino(): Array<PoSelectOption> {
    return [
        { value: "SO", label: "Solida"    },
        { value: "BA", label: "CD Solida" },
    ];
  }

  listaStatus(): Array<PoSelectOption> {
    return [
      { value: "A", label: "Pendente Confirmação" },
      { value: "0", label: "Pendente Envio"       },
      { value: "1", label: "Pendente Recebimento" },
      { value: "Z", label: "Recebido"             },
    ];
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
